import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import {
  grantAllConsent,
  denyOptionalConsent,
  hasMadeConsentChoice,
} from "@/lib/consent";

export const CookieBanner = () => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (pathname.startsWith("/wholesale")) {
      setVisible(false);
      return;
    }
    if (!hasMadeConsentChoice()) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, [pathname]);

  const accept = () => {
    grantAllConsent();
    setVisible(false);
  };

  const reject = () => {
    denyOptionalConsent();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie notice"
      className="fixed bottom-0 inset-x-0 z-50 px-4 pb-4 pointer-events-none"
    >
      <div className="pointer-events-auto mx-auto max-w-3xl rounded-xl border border-border bg-card text-card-foreground shadow-lg p-4 md:p-5 flex flex-col md:flex-row items-start md:items-center gap-3 md:gap-4">
        <p className="text-sm flex-1">
          We use essential cookies to run the site, plus optional analytics
          and advertising cookies to improve our marketing. See our{" "}
          <Link to="/privacy" className="underline text-primary">
            Privacy Policy
          </Link>
          .
        </p>
        <div className="flex items-center gap-2 self-end md:self-auto">
          <Button size="sm" variant="outline" onClick={reject}>
            Reject optional
          </Button>
          <Button size="sm" onClick={accept}>
            Accept all
          </Button>
          <button
            onClick={reject}
            aria-label="Dismiss"
            className="text-muted-foreground hover:text-foreground p-1"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
